'use strict';

var scrollbarUtil = require('../utils/liveShoppingScrollbar');
var upcomingSection = require('../utils/liveShoppingUpcomingUtils');
var endedSection = require('./liveShoppingEnded');
var upcomingScrollbarConfig = { inactiveClass: 'cc-liveShoppingUpcoming-scrollbar--inactive', maxThumbPx: 489 };
var productCarouselScrollbarConfig = { inactiveClass: 'cc-liveShoppingProductCarousel-scrollbar--inactive' };
var upcomingScrollBindings = [];

/**
 * Live Shopping Page Runtime
 *
 * Progressively loads each page section by fetching rendered HTML via AJAX
 * and injecting it into the skeleton placeholders. Each section is fetched
 * independently so a failure in one does not block the others.
 *
 * Section lifecycle:
 *   1. Skeleton placeholder visible (aria-busy="true")
 *   2. AJAX fetch fires for the section endpoint
 *   3. On success → skeleton replaced with server-rendered HTML, post-load
 *      callbacks run (carousel init, countdown, Bambuser player bindings, etc.)
 *   4. On failure → skeleton replaced with an empty container (section hidden)
 */

/**
 * Callbacks run after each section's HTML has been injected into the page.
 * Each callback re-initialises the client-side behaviour for that section.
 */
var sectionReadyCallbacks = {
    hero: function (container) {
        if (
            window.liveShoppingBambuser &&
            typeof window.liveShoppingBambuser.bindAll === 'function'
        ) {
            window.liveShoppingBambuser.bindAll(container);
        }
    },

    upcoming: function (container) {
        initUpcomingSection(container);
        if (
            window.liveShoppingBambuser &&
            typeof window.liveShoppingBambuser.bindAll === 'function'
        ) {
            window.liveShoppingBambuser.bindAll(container);
        }
    },

    ended: function (container) {
        initEndedSection(container);
        if (
            window.liveShoppingBambuser &&
            typeof window.liveShoppingBambuser.bindAll === 'function'
        ) {
            window.liveShoppingBambuser.bindAll(container);
        }
    },

    productCarousel: function () {
        if (!window.jQuery) {
            return;
        }

        var selector = '.js-liveShoppingProductCarousel';
        if ($(selector).length) {
            $('body').trigger('common:checkCarouselLength', {
                name: selector,
            });
        }

        var containers = document.querySelectorAll(
            '.js-liveShoppingProductCarousel[data-background-color]',
        );
        for (var i = 0; i < containers.length; i++) {
            var bgColor = containers[i].getAttribute('data-background-color');
            if (isSafeBackgroundColor(bgColor)) {
                containers[i].style.backgroundColor = bgColor.trim();
            }
        }

        if (
            window.productTileComponent &&
            typeof window.productTileComponent.initSlotCarousel === 'function'
        ) {
            window.productTileComponent.initSlotCarousel(
                '.js-liveShoppingProductCarousel'
            );
        }
        initProductCarouselScrollbar();
    },
};

// ─── Product carousel scrollbar ──────────────────────────────────────────────

function initProductCarouselScrollbar () {
    var sections = document.querySelectorAll('.cc-liveShoppingProductCarousel');
    for (var i = 0; i < sections.length; i++) {
        var carousel = sections[i].querySelector('.cc-em__carouselCustom');
        var thumb = sections[i].querySelector('.js-liveShoppingProductCarouselScrollThumb');
        scrollbarUtil.bindScrollbar(carousel, thumb, productCarouselScrollbarConfig);
    }
}

// ─── Upcoming section re-init ────────────────────────────────────────────────

function initUpcomingSection (container) {
    upcomingScrollBindings = upcomingSection.initUpcomingSection(
        container,
        scrollbarUtil,
        upcomingScrollbarConfig,
    );
}

// ─── Ended section re-init ───────────────────────────────────────────────

function initEndedSection (container) {
    if (endedSection && typeof endedSection.initEndedSection === 'function') {
        endedSection.initEndedSection(container);
    }
}

// ─── Utility ─────────────────────────────────────────────────────────────────

function isSafeBackgroundColor (value) {
    if (typeof value !== 'string') {
        return false;
    }

    var trimmedValue = value.trim();
    if (!trimmedValue || trimmedValue.length > 40) {
        return false;
    }

    if (window.CSS && typeof window.CSS.supports === 'function') {
        return window.CSS.supports('background-color', trimmedValue);
    }

    return /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(
        trimmedValue,
    );
}

// ─── Section loader ─────────────────────────────────────────────────────────

function fetchSectionHtml (url) {
    return $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html',
        timeout: 15000,
    });
}

function loadSection (sectionName, container, endpoints) {
    var url = endpoints[sectionName];
    if (!url) {
        container.innerHTML = '';
        return Promise.resolve();
    }

    return fetchSectionHtml(url)
        .then(function (html) {
            container.innerHTML = html;
            container.setAttribute('data-loaded', 'true');

            var callback = sectionReadyCallbacks[sectionName];
            if (typeof callback === 'function') {
                callback(container);
            }
        })
        .catch(function () {
            // Section failed to load — remove skeleton, keep page functional
            container.innerHTML = '';
        });
}

function initPage () {
    // Run localStorage.setItem('lsSkeletonDebug','1') in DevTools console,
    // then reload — skeletons will stay frozen. Clear with removeItem to restore.
    if (localStorage.getItem('lsSkeletonDebug')) {
        return;
    }

    var page = document.querySelector('.js-liveShoppingPage');
    if (!page) {
        return;
    }

    var endpointsRaw = page.getAttribute('data-section-endpoints');
    if (!endpointsRaw) {
        return;
    }

    var endpoints;
    try {
        endpoints = JSON.parse(endpointsRaw);
    } catch (e) {
        return;
    }

    var sections = page.querySelectorAll('.js-liveShoppingPage-section');
    var promises = [];

    for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var sectionName = section.getAttribute('data-section');
        if (sectionName && endpoints[sectionName]) {
            promises.push(loadSection(sectionName, section, endpoints));
        }
    }

    // After all sections are loaded, set up the global countdown interval
    Promise.all(promises).then(function () {
        // Recurring countdown update for upcoming section
        window.setInterval(function () {
            upcomingSection.updateCountdowns(document);
        }, 60000);

        // Resize handler for upcoming scroll indicator
        var upcomingSectionNode = page.querySelector(
            '[data-section="upcoming"][data-loaded]',
        );
        if (upcomingSectionNode) {
            if (!upcomingScrollBindings.length) {
                upcomingScrollBindings = upcomingSection.initUpcomingSection(
                    upcomingSectionNode,
                    scrollbarUtil,
                    upcomingScrollbarConfig,
                );
            }

            window.addEventListener('resize', function () {
                upcomingSection.updateScrollIndicators(
                    upcomingScrollBindings,
                    scrollbarUtil,
                    upcomingScrollbarConfig,
                );
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
} else {
    initPage();
}
